import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import { FullPagePreloader } from '../ui/Preloader';

export type AuthView = 'login' | 'register' | 'forgotPassword';

interface AuthGateUIProps {
    isLoading: boolean;
    initialView?: AuthView;
}

function AuthGateUI({ isLoading, initialView = 'login' }: AuthGateUIProps) {
    const [view, setView] = useState<AuthView>(initialView);

    if (isLoading) {
        return <FullPagePreloader />;
    }

    if (view === 'register') {
        return <RegisterForm onSwitchToLogin={() => setView('login')} />;
    }
    if (view === 'forgotPassword') {
        return <ForgotPasswordForm onSwitchToLogin={() => setView('login')} />;
    }
    return (
        <LoginForm
            onSwitchToRegister={() => setView('register')}
            onSwitchToForgotPassword={() => setView('forgotPassword')}
        />
    );
}

export default AuthGateUI;
